import React, { useEffect, useRef, useState } from "react";

export default function Autocomplete({
  options,
  value,
  onChange,
  placeholder,
  mode = "autocomplete",
  style,
}) {
  
  const [open, setOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const wrapperRef = useRef(null);

          
  // Currently selected label
  const selectedLabel = options.find((o) => o.value === value)?.label || "";
  const [query, setQuery] = useState(selectedLabel);
  
  // Filter options only in autocomplete mode
  const filteredOptions =
    mode === "autocomplete"
      ? isTyping
        ? options.filter((opt) =>
            opt.label.toLowerCase().includes(query.toLowerCase())
          )
        : options // show all options if not typing
      : options;
  
  // Close dropdown if click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!wrapperRef.current?.contains(e.target)) {
        setOpen(false);
        setIsTyping(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option.value);
    if (mode === "autocomplete") setQuery(option.label);
    setOpen(false);      // CLOSE dropdown
    setIsTyping(false);  // reset typing
    wrapperRef.current.querySelector("input")?.focus();
  };

  const handleInputChange = (e) => {
    if (mode === "autocomplete") {
      setQuery(e.target.value);
      setOpen(true);
      setIsTyping(true);
    }
  };


  const handleInputClick = () => {
    // Only open if not already open
    if (!open) {
      setOpen(true);
      setIsTyping(false); // restore highlight
    }
  };

  return (
    <div
      ref={wrapperRef}
      className="autocompleteWrapper"
      data-open={open ? "true" : "false"}
      data-filled={!!value}
      onClick={handleInputClick}
      style={style}
    >
      {/*JSON.stringify(selectedLabel, null, 2)*/}
      <input
        className="autocompleteInput"
        type="text"
        value={mode === "autocomplete" ? query : selectedLabel}
        placeholder={placeholder}
        readOnly={mode === "select"} // prevent typing in select mode
        onChange={handleInputChange}
      />

      {open && filteredOptions.length > 0 && (
        <ul className="dropdownStyle">
          {filteredOptions.map((opt, index) => (
            <li
              key={`${opt.value}-${index}`}
              className={`itemStyle ${
                !isTyping && opt.value === value ? "selectedItem" : ""
              }`}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

/*
const dropdownStyle = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  background: "#fff",
  border: "1px solid #ccc",
  borderRadius: 4,
  margin: 0,
  padding: 0,
  listStyle: "none",
  maxHeight: 160,
  overflowY: "auto",
  zIndex: 1000,
};

const itemStyle = {
  padding: "6px 10px",
  cursor: "pointer",
};
*/